import ExecutiveSummaryBlock from './ExecutiveSummaryBlock';
import KPIBlock from './KPIBlock';
import RecommendationBlock from './RecommendationBlock';
import KeyFindingsBlock from './KeyFindingsBlock';
import TimelineBlock from './TimelineBlock';
import ChecklistBlock from './ChecklistBlock';
import ComparisonTableBlock from './ComparisonTableBlock';
import RiskMatrixBlock from './RiskMatrixBlock';
import ExpandableSectionBlock from './ExpandableSectionBlock';
import MarkdownBlock from './UnsupportedBlock';
import { STRUCTURED_BLOCK_TYPES } from './structuredBlockUtils';

const BLOCK_REGISTRY = {
    [STRUCTURED_BLOCK_TYPES.EXECUTIVE_SUMMARY]: ExecutiveSummaryBlock,
    [STRUCTURED_BLOCK_TYPES.KPI_CARDS]: KPIBlock,
    [STRUCTURED_BLOCK_TYPES.RECOMMENDATIONS]: RecommendationBlock,
    [STRUCTURED_BLOCK_TYPES.KEY_FINDINGS]: KeyFindingsBlock,
    [STRUCTURED_BLOCK_TYPES.TIMELINE]: TimelineBlock,
    [STRUCTURED_BLOCK_TYPES.CHECKLIST]: ChecklistBlock,
    [STRUCTURED_BLOCK_TYPES.COMPARISON_TABLE]: ComparisonTableBlock,
    [STRUCTURED_BLOCK_TYPES.RISK_MATRIX]: RiskMatrixBlock,
    [STRUCTURED_BLOCK_TYPES.EXPANDABLE_SECTION]: ExpandableSectionBlock,
    [STRUCTURED_BLOCK_TYPES.MARKDOWN]: MarkdownBlock,
};

export function getBlockComponent(type) {
    return BLOCK_REGISTRY[type] || null;
}

export function isRegisteredBlockType(type) {
    return Boolean(getBlockComponent(type));
}

export { BLOCK_REGISTRY };
